import { ParseMapError } from "../../errors";

export const MAP_ID_RE = /^(\d{4}-\d{2}-\d{2})-(standard|premium)$/;

export type MapVariant = "standard" | "premium";

export function mapIdToCalendarDate(mapId: string): string {
  const match = MAP_ID_RE.exec(mapId);
  if (!match) {
    throw new ParseMapError(`Invalid mapId (expected YYYY-MM-DD-standard|premium): ${mapId}`);
  }
  return match[1];
}

export function mapIdToVariant(mapId: string): MapVariant {
  const match = MAP_ID_RE.exec(mapId);
  if (!match) {
    throw new ParseMapError(`Invalid mapId (expected YYYY-MM-DD-standard|premium): ${mapId}`);
  }
  return match[2] as MapVariant;
}

export function buildMapId(date: string, variant: MapVariant): string {
  return `${date}-${variant}`;
}

export function mapPreviewUrl(mapId: string): string {
  return `/previews/${mapId}.png`;
}

export function mapMotdUrl(mapId: string): string {
  return `/motd/${mapId}.png`;
}

export function mapOgUrl(mapId: string): string {
  return `/og/${mapId}.png`;
}
